import { ArrowForward } from '@mui/icons-material';
import { default as MUIBreadcrumbs } from '@mui/material/Breadcrumbs';
import type { BreadcrumbsProps as MUIBreadcrumbsProps } from '@mui/material/Breadcrumbs';

/**
 * Local Props for Breadcrumbs shared component
 */
type LocalBreadcrumbsProps = {
  id: string;
};

/**
 * Override props for MUI Breadcrumbs - this allow the app's to control the behavior of the Breadcrumbs component
 * as needed when overriding a prop, we should also omit the prop from the MUIBreadcrumbsProps selection
 * to ensure that the prop def when viewed only shows our override
 */
type OverriddenBreadcrumbsProps = {
  /**
   * Custom separator node.
   * @default ArrowForward
   */
  separator?: React.ReactNode;
};

export type BreadcrumbProps = LocalBreadcrumbsProps &
  OverriddenBreadcrumbsProps &
  Omit<MUIBreadcrumbsProps, 'separator'>;

export const Breadcrumbs = (props: BreadcrumbProps) => {
  const {
    // Local props
    id,

    // Overridden MUI props
    separator,

    // MUI props
    ...rest
  } = props;

  return (
    <MUIBreadcrumbs
      id={id}
      data-testid={`${id}-Breadcrumb`}
      separator={separator || <ArrowForward />}
      {...rest}
    />
  );
};
